import React from 'react';

import { Gallery as GalleryCell } from '../common/container/Cell.jsx';
import { Spaced, TitleSpaced } from '../common/container/Container.jsx';
import { withSubmission } from '../common/container/Form.jsx';
import { LinkedImage } from '../common/container/Image.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { GalleryContact } from '../common/container/Popup.jsx';
import { Galleries as GalleriesSlider } from '../common/container/Slider.jsx';
import { Follow as FollowButton } from '../common/input/Button.jsx';
import Arrows from '../common/input/Arrows.jsx';
import { Cities } from '../common/input/DropDown.jsx';
import { Input } from '../common/input/Text.jsx';

const featuredThreshold = 15;

let _GalleriesInst;
class Galleries extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            search: ''
        }

        this.sliderConfig = {
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 3000,
            items: 1,
            loop: true,
            nav: true,
            navigation: true,
            navText: ["", ""],
            singleItem: true
        };

        this.handleContact = this.handleContact.bind(this);
        this.handleContactClose = this.handleContactClose.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleToggleFollow = this.handleToggleFollow.bind(this);
    }

    componentDidMount() {
        _GalleriesInst = true;

        Artcloud.api.get(
            Artcloud.url.vendor.marketplace.galleries.get(),
            { limit: 27, offset: 0, type: 0 },
            (responseData) => {
                if (!_GalleriesInst) {
                    return;
                }
                responseData.Galleries.forEach((d, i) => {
                    if (d.Image) {
                        if (i < featuredThreshold) {
                            if (d.Bio && d.Bio.length > 160) {
                                d.Bio = d.Bio.substring(0, 160) + '...';
                            }
                            if (d.Image) {
                                d.ImgSrc = Artcloud.cdn.url(d.Image.S3Id, null, 350);
                            }
                        } else {
                            d.Height = 200;
                            d.Width = 260;
                            d.ImgSrc = Artcloud.cdn.url(d.Image.S3Id, d.Width, d.Height, 'c_fill');
                        }
                    }
                    Artcloud.mkt.galleries._isfollowing(d);
                });
                this.setState({
                    data: responseData.Galleries
                });
            },
            Artcloud.api.fail
        );
    }

    componentWillUnmount() {
        _GalleriesInst = undefined;
    }

    handleContact(d) {
        const component = this;
        if (component.contactRequest) {
            return;
        }
        component.contactRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.galleries.getid(d.Slug),
            null,
            function (responseData) {
                component.contactRequest = null;

                if (!_GalleriesInst) {
                    return;
                }
                component.setState({
                    contactModal: {
                        data: responseData,
                        visible: true
                    }
                });
            },
            function () {
                component.contactRequest = null;

                if (!_GalleriesInst) {
                    return;
                }
                component.setState({
                    contactModal: {
                        data: d,
                        visible: true
                    }
                });
            }
        );
    }

    handleContactClose() {
        this.setState({
            contactModal: undefined
        });
    }

    handleSearch(data) {
        if (!data.search || !data.search.length) {
            return;
        }
        window.location = `/search?q=${data.search}`;
    }

    handleToggleFollow(d) {
        const data = this.state.data || [];
        let gallery;
        for (let i = 0; i < data.length; i++) {
            let temp = data[i];
            if (!temp || temp.GalleryId != d.GalleryId) {
                continue;
            }
            gallery = temp;
            break;
        }
        if (!gallery) {
            return;
        }
        Artcloud.mkt.galleries.updateFollowing(gallery.GalleryId, !gallery.IsFollowing, gallery.Company, (success) => {
            if (success != true || !_GalleriesInst) {
                return;
            }
            gallery.IsFollowing = !gallery.IsFollowing;
            this.setState({
                data
            });
        });
    }

    render() {
        let featuredGalleries, slideData;
        if (this.state.data) {
            slideData = this.state.data.slice(0, featuredThreshold);
            if (this.state.data.length > featuredThreshold) {
                featuredGalleries = this.state.data.slice(featuredThreshold);
            }
        }
        return (
            <>
                <div className="section">
                    <div className="container">
                        <TitleSpaced>
                            <h2>Browse Galleries</h2>
                            <div className="section__title__controls">
                                <Search className="hide--m" onSubmit={this.handleSearch} />
                                <Cities split={true} />
                            </div>
                        </TitleSpaced>
                        {
                            slideData &&
                            <GalleriesSlider
                                className="slider--gallery--single"
                                config={this.sliderConfig}
                                data={slideData}
                                id="browse"
                                slideComponent={GallerySlide}
                                slideProps={{ onContact: this.handleContact }} />
                        }
                        <div className="section__title section__title--small">
                            <h2>Featured Galleries</h2>
                        </div>
                        <Spaced>
                            <div className="container--spaced__row">
                                <FeaturedGalleries data={featuredGalleries} onToggleFollow={this.handleToggleFollow} />
                            </div>
                        </Spaced>
                    </div>
                </div>
                <div className="section section--galleries">
                    <div className="container">
                        <div className="section--galleries__content">
                            <div className="section--galleries__left">
                                <h1>ArtCloud for galleries</h1>
                                <p>List your art on our booming marketplace reaching more than 15k art collectors every month. Totally free.</p>
                                <p>Plug into artcloud's best in class art management platform. Manage inventory, keep track of customer data, and take credit card payment on the go.</p>
                                <Arrows config={{ color: 'light', size: 'small' }} display="Learn More" link="/manager-for-galleries" />
                                <Arrows config={{ color: 'light', size: 'small' }} display="Try for Free" link="/register" />
                            </div>

                            <div className="section--galleries__right">
                                <div className="icons--grid">
                                    <IconGridItem imageClassName="i--pos">Inventory<br />Management</IconGridItem>
                                    <IconGridItem imageClassName="i--reports">Sales<br />Reports</IconGridItem>
                                    <IconGridItem imageClassName="i--crm">Art Gallery<br />CRM</IconGridItem>
                                    <IconGridItem imageClassName="i--inventory">Mobile<br />Point of Sale</IconGridItem>
                                    <IconGridItem imageClassName="i--invoice">Powerful<br />Invoicing</IconGridItem>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.contactModal &&
                    this.state.contactModal.visible &&
                    <GalleryContact data={this.state.contactModal.data} user={Artcloud.auth.user} onClose={this.handleContactClose} />
                }
            </>
        );
    }
}

function FeaturedGalleries(props) {
    let results;
    if (props.data) {
        results = props.data.map(d => <GalleryCell key={d.GalleryId} d={d} onFollowChange={props.onToggleFollow} slider={true} />);
    }
    return (
        <>
            {results}
            {
                !props.data &&
                <LoadingIndicator />
            }
        </>
    );
}

function IconGridItem(props) {
    return (
        <span className="icons--grid__item">
            <span className={`i ${props.imageClassName}`}></span>
            <span className="icons--grid__item__label">{props.children}</span>
        </span>
    );
}

class GallerySlide extends React.Component {
    constructor(props) {
        super(props);

        this.handleContact = this.handleContact.bind(this);
    }

    handleContact(event) {
        if (event) {
            event.preventDefault();
        }
        this.props.onContact(this.props.d);
    }

    render() {
        const props = this.props;
        const link = `/gallery/${props.d.Slug}`;
        return (
            <div className="item">
                <div className="gallery--single">
                    <div style={{ width: '50%' }}>
                        {
                            props.d.Image &&
                            <LinkedImage
                                alt={props.d.Company}
                                imageClass={"gallery--single__img"}
                                image={props.d.Image}
                                link={link}
                                height={320}
                                type={"fill"}
                                cols={2}
                                index={3}
                            />
                        }
                    </div>
                    <div className="gallery__info">
                        {
                            props.d.Company &&
                            <a href={link}>
                                <h4>{props.d.Company}</h4>
                            </a>
                        }
                        {
                            props.d.Location &&
                            <span className="gallery__location">{props.d.Location}</span>
                        }
                        <FollowButton data={props.d} onChange={props.onFollowChange} />
                        {
                            props.d.Bio &&
                            <p className="gallery--single__info" dangerouslySetInnerHTML={{ __html: props.d.Bio }}></p>
                        }
                        <div className="gallery--single__footer">
                            {
                                props.d.Website &&
                                <a target="_blank" href={props.d.Website}>Website</a>
                            }
                            <a href="#" onClick={this.handleContact}>Contact Gallery</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function _Search(props) {
    return (
        <Input
            config={{ color: 'lc', iconPlacement: 'ir', size: 'medium', style: 'outline' }}
            name="search"
            placeholder="Search"
            type="text"
            value={props.state.search}
            onChange={props.onChange}>
            <button className="i i--search" type="submit" />
        </Input>
    );
}
const Search = withSubmission(_Search);

export default Galleries;